import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskStudentDetailsVm } from '../my-osk-student-details-vm.model';
import { IMyOskStudentDetailsUm } from '../my-osk-student-details-um.model';
@Injectable({ providedIn: 'root' })
export class MyOskStudentDetailsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskStudentDetails`;
  }
  get(guid: string): Observable<IMyOskStudentDetailsVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', guid.toString());
    }
    return this.http.get<IMyOskStudentDetailsVm>(this.baseUrl, { headers, params });
  }
  put(myOskStudentDetailsUm: IMyOskStudentDetailsUm): Observable<IMyOskStudentDetailsVm> {
    const headers = this.createHeaders();
    return this.http.put<IMyOskStudentDetailsVm>(this.baseUrl, myOskStudentDetailsUm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
